import { useWorkspaceStore } from '../stores/workspace.store';
import { useAuthStore } from '../stores/auth.store';
import { tenantConfig } from '../lib/tenant';

export type WorkspaceRole = 'viewer' | 'user' | 'admin';

const roleLevel: Record<string, number> = { viewer: 0, user: 1, admin: 2 };

export function useWorkspaceRole() {
  const { currentWorkspace } = useWorkspaceStore();
  const { user } = useAuthStore();
  const role = (currentWorkspace?.role ?? 'viewer') as WorkspaceRole;
  const level = roleLevel[role] ?? 0;
  const isSuperAdmin = user?.isSuperAdmin ?? false;
  const isWhitelabel = tenantConfig.id !== 'default';

  // Em whitelabel, apenas super_admin pode gerenciar estrutura
  const canManageStructure = isWhitelabel
    ? isSuperAdmin
    : level >= roleLevel['admin'];

  return {
    role,
    isViewer: role === 'viewer',
    isAdmin: role === 'admin',
    canEditData: level >= roleLevel['user'],
    canManageStructure,
  };
}
